import { Injector } from "@angular/core";
import { UIRouter } from "@uirouter/core";

export function routerConfigFn(router: UIRouter, _injector: Injector) {
  const urlService = router.urlService;

  const customStringDecode = (val: string) => decodeURIComponent(val);
  const defaultStringType = urlService.config.paramTypes.types.string;
  const decodableStringType = {
    ...defaultStringType,
    ...{ decode: customStringDecode },
  };
  urlService.config.type("decodableString", decodableStringType);

  const customJSONDecode = (val: string) => JSON.parse(decodeURIComponent(val));
  const defaultJSONType = urlService.config.paramTypes.types.json;
  const decodableJSONType = {
    ...defaultJSONType,
    ...{ decode: customJSONDecode },
  };
  urlService.config.type("decodableJSON", decodableJSONType);

  urlService.rules.when(new RegExp("^.+/$"), (match: any) => {
    return match[0].slice(0, -1);
  });

  urlService.rules.when("/projects/:projectId/groups", "/projects/:projectId");
}
